/**
 * L7 Platform — front-end behavior relocated from `divi-child`.
 *
 * Owns the two pieces of front-end JS that must survive the theme swap:
 *
 *  - The `wpsk_banner` open/close + cookie-persistence behavior, ported verbatim
 *    from `divi-child/assets/js/custom/misc.js` so the home-page banner shows,
 *    dismisses, and remembers its dismissal when `divi-child` is inactive.
 *  - The `wpsk_gated_content` helper surface (`window.l7Gating`) used by the
 *    shortcode's inline HubSpot script for cookie-backed remembered unlock and
 *    known-visitor bypass.
 *
 * Depends on `js.cookie` (the `cookie-js` handle) and jQuery, both enqueued
 * ahead of this script by the plugin's Frontend\Assets.
 */
(function (window, document) {
	'use strict';

	var Cookies = window.Cookies;

	/* ===================== wpsk_banner ===================== */

	/**
	 * Wire the home-page banner's close/remember behavior.
	 *
	 * Ported from the theme's `misc.js`: clicking the close (X) stores the
	 * banner's token in the `wpsk_banner` cookie and collapses it; on load the
	 * banner is revealed only when a token is present and the visitor has not
	 * already dismissed that specific banner.
	 *
	 * @param {jQuery} $ jQuery instance.
	 * @return {void}
	 */
	function initBanner($) {
		var banner = $('.wpsk-banner');
		if (!banner.length) {
			return;
		}

		var token = banner.find('.wrap').attr('token');

		// Add ignore cookie if clicked close (X).
		banner.find('.close').on('click', function (e) {
			e.preventDefault();
			if (Cookies) {
				Cookies.set('wpsk_banner', token);
			}
			banner.addClass('collapse');
		});

		// Once loaded, confirm there is a banner to display (token) and that the
		// visitor hasn't ignored this banner before.
		$(window).on('load', function () {
			if (token != null && (!Cookies || Cookies.get('wpsk_banner') !== token)) {
				setTimeout(function () {
					banner.removeClass('collapse');
				}, 750);
			}
		});
	}

	/* ===================== wpsk_gated_content ===================== */

	// Cookie that remembers a successful gate unlock for returning visitors.
	var GATE_COOKIE = 'wpsk_gated_unlock';

	/**
	 * Whether this visitor has already unlocked gated content (known visitor).
	 *
	 * @return {boolean}
	 */
	function hasUnlock() {
		return !!(Cookies && Cookies.get(GATE_COOKIE) === '1');
	}

	/**
	 * Persist the unlock so future visits skip the gate.
	 *
	 * @return {void}
	 */
	function rememberUnlock() {
		if (Cookies) {
			Cookies.set(GATE_COOKIE, '1', { expires: 365 });
		}
	}

	// Helper surface consumed by the shortcode's inline HubSpot script. Exposed
	// on `window` so the per-resource inline script (which runs in the page body)
	// can reach the cookie-backed unlock state without re-implementing it.
	window.l7Gating = {
		cookieName: GATE_COOKIE,
		hasUnlock: hasUnlock,
		rememberUnlock: rememberUnlock
	};

	/* ===================== bootstrap ===================== */

	if (window.jQuery) {
		window.jQuery(function ($) {
			initBanner($);
		});
	}
})(window, document);
